<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-row v-if="show">
                <div class="link-name">{{config['link_name']}}</div>
                <el-button size="mini" @click="openDialog">{{config['link_name'] ? '更换链接' : '请选择链接'}}</el-button>
                <el-button v-if="config['link_name']" size="mini" class="clear-link"
                           @click="clearLink">清除链接
                </el-button>
            </el-row>
        </el-form-item>
        <!-- 链接地址对话框 -->
        <el-dialog title="请选择链接" :visible.sync="dialog.visible" @close='closeDialog'>
            <helper @select="select" @close='closeDialog'></helper>
        </el-dialog>
    </div>
</template>

<style lang="scss">
</style>

<script>

  export default {
    name: 'tms-type-link',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        show: true,
        dialog: {
          visible: false,
        }
      }
    },

    components: {},

    mounted() {
    },

    methods: {
      clearLink() {
        // show是为了视图不更新
        this.show = false;
        delete this.config['link_name'];
        delete this.config[this.field.key];
        this.config['link_type'] = 1;
        this.show = true;
      },
      openDialog() {
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(link, linkName, linkType) {
        this.config['link_name'] = linkName;
        this.config[this.field.key] = link;
        this.config['link_type'] = linkType;
        this.dialog.visible = false;
      }
    }
  }

</script>
